<div class="card-header bg-light">
  <h4 class="card-title mb-0">Apreciar Prorrogação</h4>
</div>
<div class="card-body  wrapper">
  <form [formGroup]="form" #f="ngForm" id="avaliacao-solicitacao">

    <div class="row">
      <div class="col-12 mb-3">
        <label class="form-label">Justificativa: </label>
        <textarea type="text" class="form-control form-control-sm" rows="3" formControlName="justificativa"
                  disabled></textarea>
      </div>
    </div>

    <div class="row">
      <div class="col-12 mb-3">
        <label class="form-label">Apreciação da Prorrogação: </label>
        <textarea type="text" class="form-control form-control-sm" rows="3" maxlength="300"
                  formControlName="justificativaAvaliacao"
                  [ngClass]="{ 'is-invalid': f.submitted && form.controls['justificativaAvaliacao'].invalid}"></textarea>
        <div *ngIf="submitted && form.controls['justificativaAvaliacao'].invalid" class="invalid-feedback">
          <div *ngIf="form.controls['justificativaAvaliacao'].errors.required">Campo obrigatório</div>
        </div>
      </div>
    </div>

    <div class="row" *ngIf="model?.avaliacao === 1">
      <div class="col-12 mb-3">
        <label class="form-label">Novo Prazo para Resposta *</label>
        <input type="text" class="form-control form-control-sm" placeholder="DD/MM/AAAA" bsDatepicker
               [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY' }" formControlName="prazo"
               [ngClass]="{ 'is-invalid': submitted && form.controls['prazo'].invalid && model?.avaliacao === 1}" />
        <div *ngIf="submitted && form.controls['prazo'].invalid && model?.avaliacao === 1"
             class="invalid-feedback">
          <div *ngIf="form.controls['prazo'].errors.required">Campo obrigatório</div>
          <div *ngIf="form.controls['prazo'].errors.dataMenorHoje">Data não pode ser anterior a hoje</div>
          <div *ngIf="form.controls['prazo'].errors.dataMaiorLimite">Data excede o limite permitido</div>
        </div>
      </div>
    </div>

    <div class="row col-12 p-2">
      <div class="form-check mr-4">
        <input class="form-check-input" type="radio" id="avaliacao" [value]="1" name="opcao"
               [(ngModel)]="model.avaliacao" [ngModelOptions]="{standalone: true}"
               (change)="controlaAvaliacao()" />
        <label class="form-check-label" for="gridRadios1">Aprovar
        </label>
      </div>
      <div class="form-check">
        <input class="form-check-input" type="radio" id="avaliacao" [value]="0" name="opcao" checked
               [(ngModel)]="model.avaliacao" [ngModelOptions]="{standalone: true}"
               (change)="controlaAvaliacao()" />
        <label class="form-check-label" for="gridRadios2">Negar
        </label>
      </div>
    </div>
  </form>
</div>

<div class="card-footer">
  <button type="submit" class="btn btn-success btn-sm mr-1" form="avaliacao-solicitacao" (click)="salvar()">
    <i class="fas fa-check"></i> Confirmar
  </button>

  <button type="button" class="btn btn-danger btn-sm" (click)="cancelar()">
    <i class="fas fa-times"></i> Cancelar
  </button>
</div>
